import { render, staticRenderFns } from "./BookingButton.vue?vue&type=template&id=78ebcc4e&scoped=true"
import script from "./BookingButton.vue?vue&type=script&lang=js"
export * from "./BookingButton.vue?vue&type=script&lang=js"
import style0 from "./BookingButton.vue?vue&type=style&index=0&id=78ebcc4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ebcc4e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Link: require('/vercel/path0/components/elements/Link.vue').default})
